import { CostReviewLaborByDisciplineDetailsSa } from "./CostReviewLaborByDisciplineDetailsSa";
import { GenericMaterialDetails } from "./GenericMaterialDetails";

export class CostReviewServiceAgreementAttributesExtended{
    genericMaterialDetails: GenericMaterialDetails[] = [];
    costReviewType: number = 0;
    estimateName: string = '';
    accountName: string = '';
    shipToAddress: string = '';
    sellPrice: number = 0;
    tdc: number = 0;
    gm: number = 0;
    proposalLink: string | null = null;
    opportunityLink: string | null = null;
    laborByDisciplineDetails?: CostReviewLaborByDisciplineDetailsSa[] = [];
}